import http from '../../../utils/tools/http';
import { arr } from "../../../utils";
import {
  COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_BEGIN,
  COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_SUCCESS,
  COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_FAILURE,
  COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_DISMISS_ERROR,
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchGetAllDisciplineInfo(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = http.get({ url: "/datastore/Discipline/GetAllDisciplineInfo", params: args })
      doRequest.then(
        (res) => {
          dispatch({
            type: COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchGetAllDisciplineInfoError() {
  return {
    type: COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchGetAllDisciplineInfoPending: true,
        fetchGetAllDisciplineInfoError: null,
      };

    case COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_SUCCESS:
      // The request is success
      let Data = action.data.Data;
      let secondByIDs = {}, thirdByIDs = {};
      secondByIDs = arr.arrToCacheData(Data, 'ChildNodeList');
      for (const key in secondByIDs) {
        if (secondByIDs.hasOwnProperty(key)) {
          const element = secondByIDs[key];
          thirdByIDs = { ...thirdByIDs, ...arr.arrToCacheData(element, 'ChildNodeList') }
        }
      }
      return {
        ...state,
        fetchGetAllDisciplineInfoPending: false,
        fetchGetAllDisciplineInfoSuccess: [{ Name: "全部", ID: 0 }].concat(Data),
        fetchGetAllSecondListByIDs: secondByIDs,
        fetchGetAllThirdListByIDs: thirdByIDs
      };

    case COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchGetAllDisciplineInfoPending: false,
        fetchGetAllDisciplineInfoError: action.data.error,
      };

    case COURSE_FETCH_GET_ALL_DISCIPLINE_INFO_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchGetAllDisciplineInfoError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/course/redux/fetchGetAllDisciplineInfo.js